export default "__VITE_ASSET__BFb2mKSS__"